class UrlHelper {
  constructor() {
    const urlParts = window.location.pathname.split('/')

    if (urlParts.length >= 4) {
      this.featureType = urlParts[1]
      this.pageType = urlParts[2]
      this.establishmentId = urlParts[3]
    }
  }

  encodeParam(param) {
    return encodeURIComponent(param)
      .replaceAll(/[!'()*;]/g, (c) => `%${c.charCodeAt(0).toString(16)}`) // Convert all other characters
      .replaceAll('%20', '+')
  }
}

export default new UrlHelper()
